module.exports = __webpack_public_path__ + "img/ebeb8c4.png";